import { FC } from "react";
import { useAppSelector } from "../store";
import { VviinnForms } from "../forms";
import { pageError } from "./error";

export const RegenerateReport: FC = () => {
  const companyState = useAppSelector((state) => state.company);

  const { company } = companyState;
  const reportCreationId = company?.reports?.actions?.create?.id;

  return reportCreationId ? (
    <VviinnForms formType="report" actionId={reportCreationId} />
  ) : (
    pageError()
  );
};
